import { renderDate } from '../utility/personTabGridHelper';

export const ADDRESS_GRID_COLUMNS = [
  { field: 'FullAddressText', headerName: 'Full Address', width: 260 },
  { field: 'IsPrimary', headerName: 'Is Primary', width: 110, type: 'boolean' },
  { field: 'AddressID', headerName: 'Address ID', width: 130 },
  { field: 'AddressNumberPrefix', headerName: 'Number Prefix', width: 140 },
  { field: 'AddressNumber', headerName: 'Number', width: 120 },
  { field: 'AddressNumberSuffix', headerName: 'Number Suffix', width: 140 },
  { field: 'PreDirection', headerName: 'Pre Direction', width: 140 },
  { field: 'StreetName', headerName: 'Street Name', width: 200 },
  { field: 'City', headerName: 'City', width: 160 },
  { field: 'State', headerName: 'State', width: 110 },
  { field: 'PostalCode', headerName: 'Postal Code', width: 140 },
  { field: 'PostalCodeExtension', headerName: 'Postal Code Ext', width: 150 },
  { field: 'Country', headerName: 'Country', width: 140 },
  { field: 'BldgType', headerName: 'Building Type', width: 160 },
  { field: 'BldgIdentifier', headerName: 'Building Identifier', width: 170 },
  { field: 'FloorType', headerName: 'Floor Type', width: 140 },
  { field: 'FloorIdentifier', headerName: 'Floor Identifier', width: 160 },
  { field: 'UnitType', headerName: 'Unit Type', width: 140 },
  { field: 'UnitIdentifier', headerName: 'Unit Identifier', width: 160 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
